<template>
    <div>
        <b-modal id="modalCalendarWeek" ref="modalCalendarWeek"
            :hide-footer="true" 
            :hide-header="true" 
            :centered="true">
            <img class="close" src="@/assets/img/close_red.png" @click="$bvModal.hide('modalCalendarWeek')">
            <div v-if="showLoadingFirst" class="container-loading">
                <b-spinner :label="$t('reusables.loading')" ></b-spinner>
            </div>
            <div v-else>
                <FullCalendar class="demo-app-calendar" :options="calendarOptions"  ref="fullCalendar">
                    <template v-slot:eventContent="arg">
                        <div class="fc-event-main-frame" @click="getDataClass(arg.event)">
                            <div class="fc-event-time">{{ arg.timeText }}</div>
                            <div class="fc-event-title-container">{{ arg.event.title }}</div>
                        </div>
                    </template>
                </FullCalendar>
            </div>
            
        </b-modal>

        <!--MODAL CON INFORMACION DE LA CLASE-->
        <b-modal id="modal-class-info"  centered @close="closeModalClassInfo" :hide-footer="true">
            <!-- <h6>{{$t('horario.modal-notes.text-4')}}</h6> -->
            <template #modal-header="{ close }">
                <img class="close" src="@/assets/img/close_red.png" @click="close()">
                <h5>{{$t('horario.modal-notes.text-4')}}</h5>
            </template>
            <p class="d-flex align-items-center" v-if="infoClass.stateClass != null">
                <i class="material-icons-outlined mr-3">query_stats</i>
                <span style="font-weight:600" :style="{'color': (infoClass.color)}">{{getClassStateName(infoClass.stateClass.value)}}</span>
            </p>
            <p class="d-flex align-items-center">
                <i class="material-icons-outlined mr-3">account_circle</i>
                <span>{{infoClass.personName}}</span>
            </p>
            <p class="d-flex align-items-center">
                <i class="material-icons-outlined mr-3">schedule</i>
                <span>{{infoClass != null ? getFormatDateComplete( infoClass.startDate,  infoClass.endDate, this.lang ) : ""}}</span>
            </p>
            <p v-if="infoClass.flagPlanTest" class="d-flex align-items-center">
                <i class="material-icons-outlined mr-3">quiz</i>
                <span>{{$t('reusables.test-class')}}</span>
            </p>
            <p class="d-flex align-items-center">
                <i class="material-icons-outlined mr-3">class</i>
                <span style="white-space: pre-line;">{{ infoClass.titleCourseStr }}</span>
            </p>
          
        </b-modal>

   </div>
   
</template>
<script>
import '@fullcalendar/core/vdom' // solves problem with Vite
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from "@fullcalendar/timegrid";
import { getCalendarHeaderFormat, getCalendarTitle, getFormatDateComplete, getCalendarEventTimeFormat,getHoursByTimeZoneName, horarioObtenerNameClaseEN, horarioObtenerNameClaseEnEs } from '@/assets/js/util.js';
import * as Constants from "@/assets/js/appConstants";

export default {
    data(){
        return{
            lang:localStorage.getItem('lang'),
            showLoadingFirst:true,
            formatDay : "DD",
            calendarOptions: {
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    interactionPlugin, // needed for dateClick
                ],
                events: [],
                firstDay : 1,
                //eventColor: "#4285f4",
                eventOverlap: false,
                themeSystem: "bootstrap",
                nowIndicator: true,
                headerToolbar:  {
                    left: "",
                    center:  'title',
                    right:'',
                },
                buttonText:{
                    today: this.$t('reusables.today'), 
                },
                titleFormat: function(date) {
                    return getCalendarTitle(date.date, this.lang);
                },
                height: "auto",
                allDaySlot: false,
                viewDidMount: (view) => {
                    let GMT = getHoursByTimeZoneName(this.$moment, this.$store.state.user.timeZoneName);
                    view.el.querySelector('.fc-timegrid-axis-frame').innerHTML = GMT;
                },
                initialView: "timeGridWeek",
                dayHeaderContent: (args) => {
                    return getCalendarHeaderFormat(this.$moment, args.date, this.lang,this.formatDay);
                },
                eventTimeFormat: getCalendarEventTimeFormat(),
                initialEvents: [], //INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
                editable: false,
                scrollTimeReset:false,
                selectable: false,
                selectMirror: true,
                dayMaxEvents: true,
                weekends: true,
                eventResizableFromStart: false,
               
            },
            infoClass: {},
            getFormatDateComplete:getFormatDateComplete 
        }
    },
    components: {
        FullCalendar // make the <FullCalendar> tag available
    },
    props: {
		calendarEvents: {
			type: Array,
		}
	},
    watch: { 
    	calendarEvents: function(newVal, oldVal) {
            
            this.showLoadingFirst = true;
            if(newVal.length > 0){
                this.calendarOptions.events = this.calendarEvents;
                this.showLoadingFirst = false;

                let horariosEstudiante = this.calendarEvents.filter(x => x.typeOfSchedule == Constants.TYPE_SCHEDULE.STUDENT);

                setTimeout(() => {
                    if(horariosEstudiante.length>0){
                        let calendarApi = this.$refs.fullCalendar.getApi(); 
                        let fechaInicio = horariosEstudiante[0].start;
                        //console.log("yendo a otra semana: " + fechaInicio)
                         
                        calendarApi.gotoDate(fechaInicio);
                    }
                }, 500);

            } 
		}
	},
    methods: {
        getClassStateName(stateclass_val){

            if(this.$store.state.is_teacher){
                return horarioObtenerNameClaseEN(stateclass_val);
            }else{
                return horarioObtenerNameClaseEnEs(stateclass_val);
            }

        },
        getDataClass(data){
            if(data["_def"].extendedProps.typeOfSchedule == Constants.TYPE_SCHEDULE.STUDENT){
                let json = {
                    startDate : data.startStr,
                    endDate : data.endStr,
                    personName: data["_def"].extendedProps.personName,
                    stateClass: data["_def"].extendedProps.stateClass,
                    flagPlanTest: data["_def"].extendedProps.flagPlanTest,
                    titleCourse: data["_def"].extendedProps.titleCourse,
                    titleCourseStr: data["_def"].extendedProps.titleCourse.replace("|", "\n"),
                    color: data.backgroundColor
                }
            
                this.infoClass = json;
                this.$bvModal.show("modal-class-info");
            }
            
        },
        closeModalClassInfo() {
            this.showAlertModal = false;
            this.message = "";
            this.$bvModal.hide("modal-class-info");
        },
       
    }
}
</script>